import PropTypes from 'prop-types';

const SlidesIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48 12C48 7.02944 43.9706 3 39 3H9C4.02944 3 0 7.02944 0 12V36C0 40.9706 4.02944 45 9 45H39C43.9706 45 48 40.9706 48 36V12ZM9 6.9H39L39.2798 6.90755C41.9663 7.05282 44.1 9.27724 44.1 12V13H3.9V12L3.90755 11.7202C4.05282 9.03366 6.27724 6.9 9 6.9ZM3.9 17V36C3.9 38.7228 6.03366 40.9472 8.72018 41.0925L9 41.1H39C41.7228 41.1 43.9472 38.9663 44.0925 36.2798L44.1 36V17H3.9Z"
        fill={fill}
      />
    </svg>
  </div>
);

SlidesIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

SlidesIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default SlidesIcon;
